import { EyeOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Masonry, Popconfirm, Typography } from 'antd';
import PropTypes from 'prop-types';
import VideoCover from '@/common/components/VideoCover';
import { formatAnalysisTimestamp } from '../utils/analysis';
import { formatTraceAccountName, formatTracePlatformName } from '../utils/platform';

const renderTitle = (record) => (
  <Typography.Text
    ellipsis={{
      tooltip: record.contentTitle,
    }}
    strong
  >
    {record.contentTitle || '-'}
  </Typography.Text>
);

const createMasonryItems = (dataSource) =>
  dataSource.map((record) => ({
    key: record.id,
    data: record,
  }));

const HotRadarCardList = ({
  dataSource = [],
  loading = false,
  onDetail,
  onRemove,
  removing = false,
}) => {
  if (loading) {
    return <Card loading variant="outlined" />;
  }

  if (dataSource.length === 0) {
    return <Card variant="outlined">暂无数据</Card>;
  }

  return (
    <Masonry
      columns={{
        xs: 1,
        sm: 2,
        xl: 4,
      }}
      gutter={[24, 24]}
      items={createMasonryItems(dataSource)}
      itemRender={({ data: item }) => (
        <Card
          hoverable
          cover={<VideoCover title={item.contentTitle} src={item.videoUrl} />}
          actions={[
            <Button key="detail" type="link" icon={<EyeOutlined />} onClick={() => onDetail(item)}>
              详情
            </Button>,
            <Popconfirm
              key="remove"
              title="移除爆款拆解"
              okText="确认"
              cancelText="取消"
              onConfirm={() => onRemove(item)}
            >
              <Button type="link" danger loading={removing}>
                移除
              </Button>
            </Popconfirm>,
          ]}
        >
          <Card.Meta
            title={renderTitle(item)}
            description={
              <Flex vertical gap="small">
                <Flex justify="space-between" gap="small">
                  <Typography.Text type="secondary">账号</Typography.Text>
                  <Typography.Text>{formatTraceAccountName(item) || '-'}</Typography.Text>
                </Flex>
                <Flex justify="space-between" gap="small">
                  <Typography.Text type="secondary">平台</Typography.Text>
                  <Typography.Text>{formatTracePlatformName(item.platform) || '-'}</Typography.Text>
                </Flex>
                <Flex justify="space-between" gap="small">
                  <Typography.Text type="secondary">获赞</Typography.Text>
                  <Typography.Text>{item.likeCount ?? '-'}</Typography.Text>
                </Flex>
                <Flex justify="space-between" gap="small">
                  <Typography.Text type="secondary">拆解者</Typography.Text>
                  <Typography.Text>{item.userName || '-'}</Typography.Text>
                </Flex>
                <Flex justify="space-between" gap="small">
                  <Typography.Text type="secondary">创建时间</Typography.Text>
                  <Typography.Text>
                    {formatAnalysisTimestamp(item.createdAt) || '-'}
                  </Typography.Text>
                </Flex>
              </Flex>
            }
          />
        </Card>
      )}
    />
  );
};

HotRadarCardList.propTypes = {
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      accountId: PropTypes.string,
      accountName: PropTypes.string,
      contentTitle: PropTypes.string,
      createdAt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      id: PropTypes.string,
      likeCount: PropTypes.number,
      platform: PropTypes.string,
      userName: PropTypes.string,
      videoUrl: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  onDetail: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  removing: PropTypes.bool,
};

HotRadarCardList.defaultProps = {
  dataSource: [],
  loading: false,
  removing: false,
};

export default HotRadarCardList;
